import { SpotScaling } from "./SpotScaling";

export default SpotScaling;
